// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InputParameterBase } from './InputParameterBase';
import { InputParameterType } from './InputParameterEnum';
export class InputParameterSeparator extends InputParameterBase {
    constructor(variableName = 'Empty', comment = '', inputNumber = 0) {
        super(variableName, InputParameterType.SEPARATOR, comment, inputNumber);
    }
}
